module.exports = __webpack_public_path__ + "static/media/CS2 -- 3.1.d65356b5.png";